import { FinalSignupStepSchema, KickoutStepSchema, StepSchema, StepType } from "./JourneySchema";

export function isJourneyTerminalStep(step: StepSchema): boolean {
  return step.type === StepType.Final || step.type === StepType.FinalSignup || step.type === StepType.Kickout;
}

export function isFinalSignupStep(step: StepSchema): step is FinalSignupStepSchema {
  return step.type === StepType.FinalSignup;
}

export function isKickoutStep(step: StepSchema): step is KickoutStepSchema {
  return step.type === StepType.Kickout;
}
